export enum ActionIds {
    BOOKMARK_LIKE_CLICK = 81,
    BOOKMARK_ITEM_CLICK = 82,
    PAGE_VIEW = 1,
    GENERAL_CLICK = 2,
    CALL_NUMBER_CLICK = 9,
    SHARE_CLICK_PRINT = 12,
    SHARE_OPEN_DROPDOWN = 13,
    RECOMMENDER_VIEW_ONLINE = 75,
    RECOMMENDER_CLICK_ONLINE = 76,
    RECOMMENDER_VIEW_OFFLINE = 77,
    RECOMMENDER_CLICK_OFFLINE = 78,
    OPEN_MODAL_CONTACT = 24,
    OPEN_MODAL_CALL = 8,
    OPEN_MODAL_CAROUSEL = 19,
    MAP_CLICK = 62,
    SUBMIT_CONTACT_FORM = 23,
}

export enum MLMData {
    AFFILIATE_ID = 56,
    ITEM_CHANNEL = 'immobilien',
    DEFAULT_PAGE = 1,
}
